import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { useApiClient } from '@/hooks'
import { APIErrorResponse, AttentionTask } from '@/types'
import { unwrapErrorResponse, unwrapResponse } from '@/utils'
import { QUERY_KEYS } from '@/constants'

export type UseGetAttentionTasksProps = {
  target_id: number
  target_type: AttentionTask['target_type']
  isEnabled?: boolean
}

export const useGetAttentionTasks = ({
  target_id,
  target_type,
  isEnabled = true,
}: UseGetAttentionTasksProps): UseQueryResult<
  AttentionTask[],
  APIErrorResponse
> => {
  const client = useApiClient()

  return useQuery(
    [QUERY_KEYS.ATTENTION_TASKS, target_type, target_id],
    () =>
      client
        .get(`plannings/attention_tasks/`, {
          params: {
            target_type,
            target_id,
          },
        })
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      enabled: isEnabled && !!target_id,
      refetchOnWindowFocus: false,
    }
  )
}
